module.exports = __webpack_public_path__ + "static/media/roster--highlighted.3c7786f4.png";


//////////////////
// WEBPACK FOOTER
// ./src/projects/rostery/src/roster--highlighted.png
// module id = 620
// module chunks = 0